import { useEffect, useRef, useState } from "react";
import userInfoStore, { getUser } from "@/store/user.store";
import { Loading, LoadMore } from "@/component/Loading";
import IC_CLEAR from "@/assets/record/ic_clear_mobile.svg?react";
import SearchIcon from "@/assets/record/ic_searching_mobile.svg?react";
import IC_NODE from "@/assets/record/ic_none.png";
import IC_RETRY from "@/assets/record/ic_retry.svg?react";
import { IOptions } from "@/component/Select";
import { SimpleRecord, getRecordList } from "@/services/api_list";
import { debounce } from "../../../../../utils/common";
import EasyLoading from "@/component/EasyLoading";
import DebugView from "../components/DebugView";
import IC_HOME_SEARCH from "@/assets/record/ic_search_mobile.svg?react";
import fridayReporter from "@/utils/friday";
import eventBus from "@/utils/event";
import timingStore from "@/store/timing.store";
import ItemGridMobile from "../components/RecordItem/ItemGridMobile";
import UserMobile from "@/sections/User/UserMobile";

let page = 0; // 页码

export default function MobileHome() {
  const cateCategoryList: Array<IOptions> = [
    { id: "RECENT", label: "最近" },
    { id: "SHARE_FOR_ME", label: "共享" },
    { id: "COLLECT", label: "收藏" },
  ];

  const searchText = useRef("");
  const [showDebug, setShowDebug] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cateCategory, setCateCategory] = useState("RECENT");
  const [list, setList] = useState<Array<SimpleRecord>>([]);
  const isLoadMore = useRef(false); // 是否正在加载更多
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [showLoadEnd, setShowLoadEnd] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const lastLoadErrorFn = useRef<Function | null>(null);

  const startLoading = timingStore((state) => state.startLoading);

  const ref = useRef<HTMLDivElement>(null);

  const refInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    page = 0;
    loadList({ type: cateCategory, isFirst: true });
    getUser();
    return () => {
      eventBus.removeAllListeners();
    };
  }, []);

  const onSearchInput = (content: string) => {
    setShowClear(content != "");
    if (searchText.current === content) return;
    searchText.current = content;
    page = 0;
    loadList({ type: cateCategory });
  };

  const clearHandle = () => {
    refInput.current && (refInput.current.value = "");
    searchText.current = "";
    setShowClear(false);
    page = 0;
    loadList({ type: cateCategory });
  };

  const choseCategory = (value: IOptions) => {
    switch (value.id) {
      case "RECENT":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Recent",
        });
        break;
      case "SHARE_FOR_ME":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Share",
        });
        break;
      case "COLLECT":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Favorite",
        });
        break;

      default:
        break;
    }
    page = 0;
    loadList({
      type: value.id,
      handle: () => {
        setCateCategory(value.id);
      },
    });
  };

  const loadListFn = (prop: {
    type: string;
    isFirst?: boolean;
    handle?: () => void;
  }) => {
    setLoadError(false);
    if (!isLoadMore.current) setIsLoading(true);
    getRecordList(true, prop.type, page, encodeURIComponent(searchText.current))
      .then((res) => {
        if (res.empty && prop.isFirst) {
          userInfoStore.getState().updateRecordFlag(true);
        } else {
          setList(page === 1 ? res.data : list.concat(res.data));
          userInfoStore.getState().updateRecordFlag(false);
          if (res.pageIndex >= res.totalPages) {
            setShowLoadEnd(true);
            console.log("当前页数==总页数");
          }
        }
        if (!isLoadMore.current) setIsLoading(false);
        prop.handle?.();
      })
      .catch((e) => {
        setLoadError(true);
        lastLoadErrorFn.current = () => {
          page = 1;
          isLoadMore.current = false;
          loadListFn({ ...prop });
        };
        console.log("列表加载错误", e);
      });
  };

  const loadList = (prop: {
    type: string;
    isFirst?: boolean;
    handle?: () => void;
  }) => {
    if (page === 0) {
      setList([]);
      setShowLoadEnd(false);
    }
    page++;
    loadListFn(prop);
  };

  const deleteCallback = (index: number) => {
    setList(list.filter((_, idx) => idx != index));
  };

  // 在收藏面板取消收藏才会将其在列表中删除, 否则只隐藏收藏标签
  const cancelCollectCallback = (model: SimpleRecord, index: number) => {
    if (cateCategory === "COLLECT") {
      setList(list.filter((_, idx) => idx != index));
    } else {
      list[index] = model;
      setList([...list]);
    }
  };

  const handleCallback = (model: SimpleRecord, index: number) => {
    list[index] = model;
    setList([...list]);
  };

  const onListScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const scrollTop = e.currentTarget.scrollTop; // 距顶部
    const clientHeight = e.currentTarget.clientHeight; // 可视区高度
    const scrollHeight = e.currentTarget.scrollHeight; // 滚动条总高度
    if (!isLoadMore.current && scrollTop + clientHeight + 40 >= scrollHeight) {
      if (showLoadEnd) {
        console.log("已经加载完毕，无需再次加载");
      } else {
        isLoadMore.current = true;
        setShowLoadMore(true);
        loadList({
          type: cateCategory,
          handle: () => {
            isLoadMore.current = false;
            setShowLoadMore(false);
          },
        });
      }
    }
  };

  const [showSearch, setShowSearch] = useState(false);

  const handleShowSearch = () => {
    fridayReporter.pushData({
      eventCode: "HomePage_Search",
    });
    setShowSearch(true);
  };

  const handleHideSearch = () => {
    clearHandle();
    setShowSearch(false);
  };

  const buildActionBar = () => {
    return (
      <div className="flex flex-items-center" ref={ref}>
        {cateCategoryList.map((item, index) => {
          return (
            <div
              key={item.id}
              className={`relative h-6.5 text-4.5 ${index !== cateCategoryList.length - 1 ? 'mr-6' : ''}  ${cateCategory === item.id
                ? "font-500 text-mx-secondary"
                : "text-mx-tertiary"
                }`}
              onClick={() => choseCategory(item)}
            >
              {item.label}
              {cateCategory === item.id && (
                <div
                  className={`position-absolute left-50% translate-x--50% bottom--1 w-4 h-0.5 bg-gradient-to-r from-#A28CE2  to-#80B0FF rounded-25`}
                ></div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const handleRetry = () => {
    if (lastLoadErrorFn.current) {
      lastLoadErrorFn.current();
      lastLoadErrorFn.current = null;
    }
  };

  return (
    <div className="w-full h-full flex flex-col relative">
      <EasyLoading isShow={startLoading}></EasyLoading>
      <DebugView
        isOpen={showDebug}
        onClose={() => {
          setShowDebug(false);
        }}
      ></DebugView>

      {isLoading && !loadError && (
        <div className="flex-1 flex flex-items-center flex-justify-center absolute top-50% left-50% translate-x--50% translate-y--50%">
          <Loading />
        </div>
      )}
      {loadError && (
        <div className="flex flex-col flex-justify-center flex-items-center flex-1 absolute top-50% left-50% translate-x--50% translate-y--50%">
          <IC_RETRY className="w-20 h-20" />
          <span className="mt-1 text-mx-quaternary text-3.5">加载超时</span>
          <div
            className="mt-4 b-1 border-solid b-#DBDEE4 w-22 h-8 rounded-1.5 flex justify-center items-center text-mx-secondary text-3.5 cursor-pointer"
            onClick={handleRetry}
          >
            重试
          </div>
        </div>
      )}
      <div className="mt-4 h-11 px-5 flex items-center justify-between">
        {!showSearch && <UserMobile />}
        {!showSearch && buildActionBar()}
        {showSearch ? (
          <div className="flex items-center w-full mb-2.5">
            <div
              className={`flex-1 rounded-2.5 flex items-center font-40 b-1 b-solid h-9 bg-white b-#ECEEF3`}
            >
              <SearchIcon className="size-4 ml-4 mr-2" />
              <input
                ref={refInput}
                className="my-input b-0 outline-0 text-3 text-mx-secondary flex-1 mr-2"
                placeholder="文件标题"
                autoFocus
                onChange={debounce((e) => {
                  onSearchInput(
                    (e as React.ChangeEvent<HTMLInputElement>).target.value
                  );
                }, 500)}
              ></input>
              {refInput.current?.value && (
                <IC_CLEAR
                  className="mr-3 cursor-pointer"
                  onClick={handleHideSearch}
                />
              )}
            </div>
            <div
              className="text-mx-secondary text-3.75 ml-5"
              onClick={handleHideSearch}
            >
              取消
            </div>
          </div>
        ) : (
          <IC_HOME_SEARCH
            className="cursor-pointer flex items-center"
            onClick={handleShowSearch}
          ></IC_HOME_SEARCH>
        )}
      </div>
      {!isLoading &&
        !loadError &&
        (list.length === 0 ? (
          <div className="flex flex-col flex-justify-center flex-items-center flex-1 absolute top-50% left-50% translate-x--50% translate-y--50%">
            <img src={IC_NODE} className="w-20 h-20" />
            <span className="mt-1 text-mx-quaternary text-3.5">
              {showClear ? "无匹配的搜索结果" : "暂无会议记录"}
            </span>
          </div>
        ) : (
          <div
            className="flex flex-col flex-1 overflow-y-auto my-scrollbar px-4 "
            onScroll={(e) => {
              onListScroll(e);
            }}
          >
            <div className="w-full mt-2">
              {list.map((m, index) => (
                <ItemGridMobile
                  key={m.streamName + index}
                  isDeleted={m.isDeleted || m.subscribed === false}
                  model={m}
                  deleteCallback={() => {
                    deleteCallback(index);
                  }}
                  cancelCollectCallback={(model) => {
                    cancelCollectCallback(model, index);
                  }}
                  handleCallback={(model) => {
                    handleCallback(model, index);
                  }}
                />
              ))}
            </div>
            {showLoadMore && <LoadMore />}
          </div>
        ))}
    </div>
  );
}
